<template>
  <div v-if="count" class="op-badge badge" :class="badgeColor" :style="badgeStyle">{{ count }}</div>
</template>

<script>
import configMixin from '@/mixins/configMixin';
import navigationMixin from '@/mixins/navigationMixin';

export default {
  name: 'BottomNavBadge',
  mixins: [configMixin, navigationMixin],
  props: {
    bottomNavItem: Object,
    moduleConfig: Object,
    badgeColor: String,
  },
  methods: {
    badgeStyle() {
      return {
        background: this.badgeColor,
      };
    },
  },
  computed: {
    count() {
      if (this.moduleConfig) {
        return this.mx_unreadCount(this.moduleConfig);
      }
      return null;
    },
  },
};
</script>

<style scoped>
.badge {
  width: 18px !important;
  height: 18px !important;
  font-size: 10px !important;
  transform: translate(10px, 2px);
}
</style>